import React, { useContext, useEffect } from 'react';
import LoadingIcon from '../../components/loading/loading-icon';
import InfiniteScroll from 'react-infinite-scroller';
import PostRow from '../../components/posts/post-row';
import PostItem from '../../components/posts/post-item';

import { Context } from '../../../context/global-data-provider';
import {
  GCategoryDataContext,
  PostsListContext,
  PostsLoadedContext,
  PostsLoaderContext,
} from '../../../context/g-category-posts-list-provider';

import './posts-list-style.css';

function GCategoryPostsList({ category }) {
  const [posts, hasMore] = useContext(PostsListContext);
  const [loadPosts, pageNumber] = useContext(PostsLoaderContext);
  const [postsLoaded] = useContext(PostsLoadedContext);

  const { options } = useContext(Context);
  const [categoryData] = useContext(GCategoryDataContext);

  useEffect(() => {
    document.title = options.title + ' • ' + categoryData.title;
  }, [categoryData]);

  function loadMore(pn) {
    loadPosts(category, pn);
  }

  let i_s_setting = {
    pageStart: pageNumber,
    loadMore: loadMore,
    hasMore: hasMore,
    useWindow: true,
    loader: <LoadingIcon className={'post-loading'} width={32} height={32} fill={'#555555'} key={0} />,
  };

  if (postsLoaded) {
    return (
      <div className="posts-list">
        <article className="f-grow-1">
          <InfiniteScroll {...i_s_setting}>
            {posts.map((row, i) => {
              return (
                <PostRow key={i}>
                  {row.map((post) => {
                    return <PostItem data={post} key={post.id} />;
                  })}
                </PostRow>
              );
            })}
          </InfiniteScroll>
        </article>
      </div>
    );
  } else {
    return (
      <div className="posts-list">
        <LoadingIcon className={'post-loading'} width={32} height={32} fill={'#555555'} key={0} />
      </div>
    );
  }
}

export default GCategoryPostsList;
